module.exports = __webpack_public_path__ + "static/pic05-4bf32763b0afaf602e0ec43c3d0e2926.jpg";